// Am Computer geöffnet (12.10.2026, Sichtprüfung): Die Aufnahme braucht die Handykamera. Ein QR-Code
// bringt dieselbe Seite aufs Handy; am Computer geht es trotzdem weiter (Fotos aus der Galerie).

import { useEffect, useState } from "react";
import qrcode from "qrcode-generator";
import { inPlayApp } from "../play.ts";

/** Computer: feiner Zeiger, breiter Bildschirm, nicht in der Play-Store-App. */
function amComputer(): boolean {
  try {
    return window.matchMedia("(pointer: fine)").matches && window.innerWidth >= 900 && !inPlayApp();
  } catch {
    return false;
  }
}

export function AufsHandy(props: { url?: string }) {
  const [zeigen, setZeigen] = useState(false);
  useEffect(() => setZeigen(amComputer()), []);
  if (!zeigen) return null;
  const url = props.url ?? window.location.origin + window.location.pathname;
  const qr = qrcode(0, "M");
  qr.addData(url);
  qr.make();
  const svg = qr.createSvgTag({ cellSize: 5, margin: 2, scalable: true });
  return (
    <section className="card aufs-handy">
      <div className="qr" aria-hidden="true" dangerouslySetInnerHTML={{ __html: svg }} />
      <div>
        <h2>Am besten mit dem Handy</h2>
        <p>Scannen Sie den Code mit der Kamera Ihres Handys. Dann fotografieren Sie Ihre Räume direkt, ohne Fotos zu übertragen.</p>
        <p className="hint">Sie können auch hier am Computer weitermachen und Fotos aus Ihren Dateien wählen.</p>
      </div>
    </section>
  );
}
